// Container.js
import React from 'react';
import Crystal from './Crystal';
import { getTubeHeight, hasHiddenPieces } from './gameLogic';

const Container = ({ 
  crystals, 
  selected, 
  onClick, 
  config, 
  colors,
  containerIndex,
  isValidTarget,
  selectedContainerIndex,
  animatingCrystal = null,
  theme,
  level,
  isHardMode,
  hintHighlight = null
}) => {
  const maxSegments = getTubeHeight(level, isHardMode);
  const scale = config.scale || 1;
  const containerHeight = maxSegments * config.crystalHeight * scale;
  const containerWidthPx = Math.round((config.containerWidth || 60) * scale);
  const marginPx = Math.max(2, Math.round(8 * scale));
  const includesHiddenPieces = hasHiddenPieces(level, isHardMode);

  
  const getHighlightStyle = () => {
    if (selected) {
      return `${theme.selectedBorder} border-4`;
    }
    if (selectedContainerIndex !== null && isValidTarget && isValidTarget(containerIndex)) {
      return `${theme.validTargetBorder} border-4`;
    }
    if (hintHighlight === 'from') {
      return `${theme.hintFromBorder} border-4 animate-pulse`;
    }
    if (hintHighlight === 'to') {
      return `${theme.hintToBorder} border-4 animate-pulse`;
    }
    return `${theme.border} border-2`;
  };

  const getCrystalPositions = () => {
    let currentPosition = maxSegments;
    return crystals.map((crystal) => {
      currentPosition -= crystal.size;
      return {
        crystal,
        position: currentPosition
      };
    });
  };

  const crystalPositions = getCrystalPositions();

  return (
    <div 
      className={`
        relative
        rounded-lg
        ${getHighlightStyle()}
        cursor-pointer
        transition-all
        duration-200
        ${theme.containerHover}
        ${theme.containerBg}
      `}
      style={{
        height: `${containerHeight}px`,
        width: `${containerWidthPx}px`,
        margin: `${marginPx}px`,
      }}
      onClick={() => onClick(containerIndex)}
    >
      <div className={`absolute inset-0 rounded-lg bg-opacity-50 ${theme.containerBg}`} />
      
      <div className="relative h-full">
        {crystalPositions.map(({crystal, position}, index) => {
          const colorData = colors[crystal.color];
          //console.log('Rendering crystal:', { color: crystal.color, position, isRevealed: crystal.isRevealed });
          
          return (
            <Crystal
              key={`${containerIndex}-${index}`}
              color={colorData.color}
              pattern={colorData.pattern}
              size={crystal.size}
              position={position}
              totalPositions={maxSegments}
              config={{
                ...config,
                containerHeight: containerHeight
              }}
              isAnimating={false}
              isRevealed={crystal.isRevealed}
            />
          );
        })}
      </div>

      {animatingCrystal && (animatingCrystal.fromIdx === containerIndex || 
                           animatingCrystal.toIdx === containerIndex) && (
        <Crystal
          color={colors[animatingCrystal.crystal.color].color}
          pattern={colors[animatingCrystal.crystal.color].pattern}
          size={animatingCrystal.crystal.size}
          isAnimating={true}
          animationProgress={animatingCrystal.progress}
          config={{
            ...config,
            containerHeight: containerHeight
          }}
          totalPositions={maxSegments}
          isRevealed={animatingCrystal.crystal.isRevealed}
        />
      )}
    </div>
  );
};

export default Container;